import { ITaxes } from '../types/taxes.type';
import $http from '../services/AxiosInstance';
import { ISecurityMeasures } from '../types/securityMeasures.type';

interface Params {
  page?: number;
  search?: string;
  companyId?: number;
  deleted?: boolean;
}

class TaxesRepository {
  static async getTaxes(params: Params = {}) {
    try {
      let url = `/taxes`;
      if (params.page) {
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.companyId) {
        url += `&companyId=${params.companyId}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createTax(
    data: ITaxes,
  ): Promise<ITaxes> {
    try {
      const response = await $http.post('/taxes', data);

      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateTax(
    data: ITaxes,
  ): Promise<ITaxes> {
    try {
      const response = await $http.patch(`/taxes/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deleteTax(id: number): Promise<number> {
    try {
      const response = await $http.delete(`/taxes/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async restoreTax(id: number): Promise<number> {
    try {
      const response = await $http.post(`/taxes/restore/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async calculatePrice(tax: ITaxes): Promise<{calculation: number}> {
    try {
      const response = await $http.post(`/taxes/calculate-price`, tax);
      return response.data;
    } catch (error: any) {
      throw Error(error.message);
    }
  }
  static async calculatePriceToDynamicTax(tax: ITaxes): Promise<{calculation: number}> {
    try {
      const response = await $http.post(`/taxes/calculate-price-dynamic-tax`, tax);
      return response.data;
    } catch (error: any) {
      throw Error(error.message);
    }
  }

}

export default TaxesRepository;
